module.exports = __webpack_public_path__ + "static/media/Emilia-oval.f40bdd2c.jpg";